import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, Paper, TablePagination,TableCell, TableHead, TableRow, TableContainer, Table, TableBody
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useAlert } from 'react-alert';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'TRANSPORTDEDUCTIONDETAILSREPORT';

export default function TransportDeductionDetailsReport(props) {
  const componentRef = useRef();
  const alert = useAlert();
  const [title] = useState("Transport Deduction Details Report");
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [applicableDate, setApplicableDate] = useState(null);
  const [transportDeductionDetailsReportDetails, setTransportDeductionDetailsReportDetails] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: '',
    year: '',
    month: ''
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [RouteList, setRouteList] = useState([]);
  const [mappingData, setMappingData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    registrationNumber: '',
    fromDate: '',
    toDate: '',
    applicableMonth: '',
  })
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown(),
    );
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
  }, [transportDeductionDetailsReportDetails.groupID]);

  useEffect(() => {
    getRoutesByFactoryID([]);
  }, [transportDeductionDetailsReportDetails.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTRANSPORTDEDUCTIONDETAILSREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setTransportDeductionDetailsReportDetails({
      ...transportDeductionDetailsReportDetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(transportDeductionDetailsReportDetails.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(transportDeductionDetailsReportDetails.factoryID);
    setRouteList(routes);
  }

  async function GetDetails() {
    let model = {
      groupID: parseInt(transportDeductionDetailsReportDetails.groupID),
      factoryID: parseInt(transportDeductionDetailsReportDetails.factoryID),
      routeID: parseInt(transportDeductionDetailsReportDetails.routeID),
      registrationNumber: transportDeductionDetailsReportDetails.registrationNumber,
      fromDate: moment(startDate.toString()).format().split('T')[0],
      toDate: moment(endDate.toString()).format().split('T')[0],
      applicableMonth: applicableDate ? moment(applicableDate).format('MM') : '',
      applicableYear: applicableDate ? moment(applicableDate).format('YYYY') : ''
    };
    getSelectedDropdownValuesForReport(model);
    const mappingData = await services.GetTransportDeductionDetailsReportDetails(model);
    if (mappingData.data.length > 0) {
      setMappingData(mappingData.data);
      setPage(0);
    } else {
      setMappingData([]);
      alert.error("No Records To Display");
    }
  }

  async function createDataForExcel(mappingData, searchData) {
  const res = [];

  if (mappingData && mappingData.length > 0) {
    mappingData.forEach((x) => {
      const row = {
        'Date': new Date(x.transactionDate).toISOString().split('T')[0],
        'Route': x.routeName,
        'Registration Number': x.registrationNumber,
        'Customer Name': x.customerName,
        'Transport Rate': parseFloat(x.transportRate),
        'Applicable Month': x.applicableMonth,
        'Amount (Rs.)': parseFloat(x.amount),
      };
      res.push(row);
    });
  }

  res.push({});
  res.push({
      'Date': 'Total',
      'Amount (Rs.)': parseFloat(mappingData.reduce((sum, row) => sum + row.amount, 0)),
    });
  res.push({});

  res.push({
    'Date': "Group: " + searchData.groupName,
    'Route': "Factory: " + searchData.factoryName,
    'Registration Number': searchData.routeName ? "Route: " + searchData.routeName : "Route: All Routes",
  });

  res.push({
    'Date': "From Date: " + searchData.fromDate,
    'Route': "To Date: " + searchData.toDate,
    'Registration Number': searchData.registrationNumber ? "Registration Number: " + searchData.registrationNumber : "Registration Number: All Registration Number",
    'Customer Name': searchData.applicableMonth ? "Applicable Month: " + searchData.applicableMonth : "",
  });
  return res;
}


async function createFile() {
  var file = await createDataForExcel(mappingData, selectedSearchValues);
  
  var settings = {
    sheetName: 'Transport Report',
    fileName:
      'Transport Deduction Details Report - ' +
      selectedSearchValues.groupName +
      ' - ' +
      selectedSearchValues.factoryName +
      ' - ' +
      selectedSearchValues.fromDate +
      '-' +
      selectedSearchValues.toDate,
    writeOptions: {},
  };

  let keys = Object.keys(file[0]);
  let tempcsvHeaders = [];

  keys.map((sitem) => {
    tempcsvHeaders.push({ label: sitem, value: sitem });
  });

  let dataA = [
    {
      sheet: 'Transport Report',
      columns: tempcsvHeaders,
      content: file,
    },
  ];

  xlsx(dataA, settings);
}


  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            size: A4 Protrait ;
            background-color: white !important;
            padding:2px
        }
        body {
            size: A4 Protrait ;
            background-color: white !important;
        }
    }`;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    if (target.name === 'groupID') {
      setTransportDeductionDetailsReportDetails({
        ...transportDeductionDetailsReportDetails,
        groupID: value,
        factoryID: 0,
        routeID: 0,
        registrationNumber: ''
      });
      setStartDate(new Date());
      setEndDate(new Date());
      setApplicableDate(null);
    } else if (target.name === 'factoryID') {
      setTransportDeductionDetailsReportDetails({
        ...transportDeductionDetailsReportDetails,
        factoryID: value,
        routeID: 0,
        registrationNumber: ''
      });
      setStartDate(new Date());
      setEndDate(new Date());
      setApplicableDate(null);
    } else if (target.name === 'routeID') {
      setTransportDeductionDetailsReportDetails({
        ...transportDeductionDetailsReportDetails,
        routeID: value,
        registrationNumber: ''
      });
    }else{
      setTransportDeductionDetailsReportDetails({
      ...transportDeductionDetailsReportDetails,
      [e.target.name]: value
    });
    }
    setMappingData([]);
  }
  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: RouteList[searchForm.routeID],
      registrationNumber: searchForm.registrationNumber,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
      applicableMonth: applicableDate ? moment(applicableDate).format('MM-YYYY') : '',
    })
  }

  function clearData() {
      setTransportDeductionDetailsReportDetails({
        ...transportDeductionDetailsReportDetails,
        routeID: 0,
        registrationNumber: '',
      });
      setMappingData([]);
      setApplicableDate(null);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: transportDeductionDetailsReportDetails.groupID,
              factoryID: transportDeductionDetailsReportDetails.factoryID,
              registrationNumber: transportDeductionDetailsReportDetails.registrationNumber,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
              })
            }
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={transportDeductionDetailsReportDetails.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={transportDeductionDetailsReportDetails.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={transportDeductionDetailsReportDetails.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Routes--</MenuItem>
                              {generateDropDownMenu(RouteList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              size='small'
                              onChange={(e) => {
                                  const value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                                  e.target.value = value;
                                  handleChange(e);
                              }}                              
                              value={transportDeductionDetailsReportDetails.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                            >
                            </TextField>
                          </Grid>
                            <Grid item md={3} xs={12}>
                                <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date *</InputLabel>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        fullWidth
                                        inputVariant="outlined"
                                        format="dd/MM/yyyy"
                                        margin="dense"
                                        name='startDate'
                                        id='startDate'
                                        value={startDate}
                                        maxDate={new Date()}
                                        onChange={(e) => {
                                            setStartDate(e)
                                            setMappingData([])
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        autoOk
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date *</InputLabel>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        fullWidth
                                        inputVariant="outlined"
                                        format="dd/MM/yyyy"
                                        margin="dense"
                                        name='startDate'
                                        id='startDate'
                                        value={endDate}
                                        onChange={(e) => {
                                            setEndDate(e)
                                            setMappingData([])
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        autoOk
                                        minDate={startDate}
                                        maxDate={new Date()}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        autoOk
                                        variant="inline"
                                        openTo="month"
                                        views={["year", "month"]}
                                        label="Applicable Month"
                                        helperText="Select applicable month"
                                        value={applicableDate}
                                        onChange={(e) => {
                                            setApplicableDate(e)
                                            setMappingData([])
                                        }}
                                        maxDate={new Date()}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                        <Grid container justify="flex-end" spacing={3}>
                          <Box display="flex" justifyContent="flex-end" p={2} mt={2.5}>
                            <Button
                              size='small'
                              color="primary"
                              type="reset"
                              variant="outlined"
                              onClick={() => clearData()}
                            >
                              Clear
                            </Button>
                            <div>&nbsp;</div>
                            <Button
                              size='small'
                              color="primary"
                              variant="contained"
                              type='submit'
                              onClick={() => trackPromise(GetDetails())}
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>
                      {mappingData.length > 0 ?
                        <Box minWidth={1050} p={2}>
                            <TableContainer component={Paper} elevation={2}>
                            <Table aria-label="styled table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Date</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Route</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Registration Number</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Customer Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Transport Rate</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Applicable Month</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>Amount (Rs.)</TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {mappingData.slice(page * limit, page * limit + limit).map((row, i) => (
                                    <TableRow key={i}>
                                      <TableCell align="center" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {new Date(row.transactionDate).toISOString().split('T')[0]}
                                      </TableCell>
                                      <TableCell align="left" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {row.routeName}
                                      </TableCell>
                                      <TableCell align="left" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {row.registrationNumber}
                                      </TableCell>
                                      <TableCell align="left" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {row.customerName}
                                      </TableCell>
                                      <TableCell align="right" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {row.transportRate?.toFixed(2)}
                                      </TableCell>
                                      <TableCell align="center" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {row.applicableMonth}
                                      </TableCell>
                                      <TableCell align="right" style={{ padding: '6px 12px', border: '1px solid black' }}>
                                        {row.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                    </TableRow>
                                  ))}

                                  <TableRow>
                                    <TableCell colSpan={6} align="left" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>
                                      Total
                                    </TableCell>
                                    <TableCell align="right" style={{ fontWeight: 'bold', fontSize: '15px', padding: '6px 12px', border: '1px solid black' }}>
                                      {mappingData.reduce((sum, row) => sum + row.amount, 0).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                              <TablePagination
                                component="div"
                                count={mappingData.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 25]}
                              />
                            </TableContainer>
                          </Box>
                          : null}
                      {mappingData.length > 0 &&
                        <>
                          <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                              color="primary"
                              id="btnRecord"
                              type="button"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorRecord}
                              onClick={createFile}
                              size='small'
                            >
                              EXCEL
                            </Button>
                            <ReactToPrint
                              documentTitle={"Transport Deduction Details Report"}
                              trigger={() => (
                                <Button
                                  color="primary"
                                  id="btnRecord"
                                  type="button"
                                  variant="contained"
                                  style={{ marginRight: '1rem' }}
                                  className={classes.colorCancel}
                                  size='small'
                                >
                                  PDF
                                </Button>
                              )}
                              pageStyle={getPageMargins()}
                              content={() => componentRef.current}
                            />
                            <div hidden={true}>
                              <CreatePDF
                                ref={componentRef}
                                searchData={selectedSearchValues}
                                mappingData={mappingData}
                                transportDeductionDetailsReportDetails={transportDeductionDetailsReportDetails}
                              />
                            </div>
                          </Box>
                        </>
                      }
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}